import store from './../store';
import Auth from './auth.service';
import { emulation, resume } from './../actions/user';
import Types from '../constants/user';

const refreshTokenLimit = 5;

class TokenService {
    constructor() {
        if (TokenService.instance) {
            return TokenService.instance;
        }

        this.isRefreshing = false;
        this.isRefreshingEmulation = false;
        this.refreshPromise = null;
        this.refreshEmulationPromise = null;
        this.refreshCounts = 0;

        TokenService.instance = this;
        return this;
    }

    async refreshAccessToken(retryRequest) {
        if (this.refreshCounts > refreshTokenLimit) {
            console.error('Refresh token limit exceeded. Please log in again.');
            store.dispatch({ type: Types.LOGOUT });
            return Promise.reject(new Error('Refresh token limit exceeded.'));
        }
        if (this.isRefreshing) {
            return this.refreshPromise
                .then(() => retryRequest())
                .catch(error => {
                    console.error('Error during retryRequest execution:', error);
                    throw error;
                });
        }

        this.isRefreshing = true;
        const refresh_token = store.getState().user.refresh_token;
        this.refreshCounts += 1;

        this.refreshPromise = Auth.Resume({ refresh_token })
            .then(response => {
                store.dispatch(resume(response));
                return response.access_token;
            })
            .catch(error => {
                console.error('Error refreshing token:', error);
                store.dispatch({ type: Types.LOGOUT });
                throw error;
            })
            .finally(() => {
                this.isRefreshing = false;
                this.refreshPromise = null;
            });

        try {
            await this.refreshPromise;
            return retryRequest();
        } catch (error) {
            console.error('Error in refreshAccessToken final retry:', error);
            throw error;
        }
    }

    async refreshEmulationToken(retryRequest) {
        if (this.refreshCounts > refreshTokenLimit) {
            console.error('Refresh token limit exceeded. Please log in again.');
            store.dispatch({ type: Types.LOGOUT });
            return Promise.reject(new Error('Refresh token limit exceeded.'));
        }
        if (this.isRefreshingEmulation) {
            return this.refreshEmulationPromise
                .then(() => retryRequest())
                .catch(error => {
                    console.error('Error during retryRequest execution:', error);
                    throw error;
                });
        }
        this.refreshCounts += 1;

        this.isRefreshingEmulation = true;

        const storeItems = store.getState();
        this.refreshEmulationPromise = emulation({
            id: storeItems.user.emulation[storeItems.user.emulation.length - 1].user_id,
        })(store.dispatch, store.getState)
            .then(response => {
                return response;
            })
            .catch(error => {
                store.dispatch({ type: Types.LOGOUT });
                throw error;
            })
            .finally(() => {
                this.isRefreshingEmulation = false;
                this.refreshEmulationPromise = null;
            });

        try {
            await this.refreshEmulationPromise;
            return retryRequest();
        } catch (error) {
            console.error('Error in refreshEmulationAccessToken final retry:', error);
            throw error;
        }
    }
}

export const tokenService = new TokenService();
